import moment from 'moment'

export const formatTime = (seconds: number) => {
  const duration = moment.duration(seconds, 'seconds')
  const hours = duration.hours().toString().padStart(1, '0')
  const minutes = duration.minutes().toString().padStart(2, '0')
  const secondsFormatted = duration.seconds().toString().padStart(2, '0')

  return `${hours}:${minutes}:${secondsFormatted}`
}

interface Utterance {
  speaker?: any
  transcript: string
  start: number
  channel?: number
}

export const formatTranscript = (utterances: Utterance[]) => {
  type FormattedPart = {
    speaker: any
    transcript: string
    start: string
  }

  const parts: FormattedPart[] = []
  let currentObject: FormattedPart | null = null
  const speakerMap = new Map<string, any>()
  let nextSpeakerId = 1

  for (const utterance of utterances) {
    const currentChannel = utterance.channel ?? 0

    let speakerKey: string
    let mappedSpeaker: any

    if (!utterance.speaker) {
      speakerKey = `channel_${currentChannel}`

      if (!speakerMap.has(speakerKey)) {
        speakerMap.set(speakerKey, nextSpeakerId)
        nextSpeakerId += 1
      }
      mappedSpeaker = speakerMap.get(speakerKey)
    } else {
      speakerKey = `${utterance.speaker}_${currentChannel}`

      if (!speakerMap.has(speakerKey)) {
        const isName = Number.isNaN(Number(utterance.speaker))
        if (isName) {
          speakerMap.set(speakerKey, utterance.speaker)
        } else {
          speakerMap.set(speakerKey, nextSpeakerId)
          nextSpeakerId += 1
        }
      }
      mappedSpeaker = speakerMap.get(speakerKey)
    }

    if (currentObject && mappedSpeaker === currentObject.speaker) {
      currentObject.transcript += ` ${utterance.transcript}`
    } else {
      if (currentObject !== null) {
        parts.push(currentObject)
      }

      currentObject = {
        speaker: mappedSpeaker,
        transcript: utterance.transcript,
        start: formatTime(utterance.start)
      }
    }
  }

  if (currentObject !== null) {
    parts.push(currentObject)
  }

  return parts
}

export const renderSpeaker = (
  speaker: any,
  client?: { first_name: string; last_name: string }
) => {
  if (typeof speaker === 'string') {
    if (speaker === 'Client' && client) {
      return `${client.first_name} ${client.last_name}`
    }
    return speaker
  }
  return `Speaker #${speaker}`
}
